export default __webpack_public_path__ + "static/media/twicon.2c11fd9e.svg";